function lazyLoadImg() {
    var imgs = document.querySelectorAll(".lazy2");

    for (var i = 0; i < imgs.length; i++) {
        src = (imgs[i].dataset.src === undefined) ? imgs[i].src : imgs[i].dataset.src;
        srcset = imgs[i].getAttribute("data-srcset") || "";
        
        if (src && src !== "") {
            imgs[i].src = src;
        }
        if (srcset && srcset !== "") {
            imgs[i].srcset = srcset;
        }
        imgs[i].classList.remove("lazy2");
    }
}

function lazyLoadImg2() {
    var imgs = document.querySelectorAll(".lazy3");

    for (var i = 0; i < imgs.length; i++) {
        src = (imgs[i].dataset.src === undefined) ? imgs[i].src : imgs[i].dataset.src;
        srcset = imgs[i].getAttribute("data-srcset") || "";
        var elemRect = imgs[i].getBoundingClientRect();

        if (elemRect.top < windowHeight) {
            if (src && src !== "") {
                imgs[i].src = src;
            }
            if (srcset && srcset !== "") {
                imgs[i].srcset = srcset;
            }
            imgs[i].classList.remove("lazy3");
        }
    }
}
